import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService, DialogService, CoreService, DspxCardSetBaseFormComponent } from 'dspx-core';
import { API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { TEMPLATES } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { ResponseParserService } from 'src/app/services/response-parser.service';
import { VptasSpecialistGridFilterRequest } from 'src/app/interfaces/vptas-specialist-grid-filter-request.interface';
import { FILTER_QUESTION_CODES, NAV_TAB_NUMBERS, PAGE_NUMBERS, QUESTION_CODES, SECTION_CODES } from 'src/app/constants/app-data.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { Mapper, MapperBuilder } from 'src/app/helpers/mapper';
import { VictorianPatientTransportAssistanceSchemeApplicationRebateCalculationRateRequest } from 'src/app/interfaces/victorian-patient-transport-assistance-scheme-application-rebate-calculation-rate-request.interface';
import { VptasLgaGridFilterRequest } from 'src/app/interfaces/vptas-lga-grid-filter-request.interface';
import { nameof } from 'src/app/helpers/nameof';

@Component({
  selector: 'app-vptas-lga-list',
  templateUrl: './vptas-lga-list.component.html',
  styleUrl: './vptas-lga-list.component.scss'
})
export class VptasLGAListComponent  extends BaseCardSetListComponent implements OnInit, OnDestroy{
    @ViewChild(DspxCardSetBaseFormComponent)
    private set _baseForm(value: DspxCardSetBaseFormComponent) {
      this.baseForm = value;
    }

  activeDialog: string = '';

  filterQuestionToFilterModelMapper: Mapper;
  
  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private coreService: CoreService,
    private errorService: ErrorService,
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.vptasLgaList,
      () => {
        return API_ENDPOINTS.dashboard.GetVptasLgaList;
      },
      false);

      this.filterQuestionToFilterModelMapper =
        new MapperBuilder()
          .WithDefaultTargetFieldMapping(/Filter$/i, "") // When target field name is not specified, just use the source field's name, but drop "Filter" from the end
          .MapFrom(FILTER_QUESTION_CODES.vptasLgaListForm.localityFilter, null, nameof<VptasLgaGridFilterRequest>('locality'))
          .MapFrom(FILTER_QUESTION_CODES.vptasLgaListForm.postcodeFilter, null, nameof<VptasLgaGridFilterRequest>('postcode'))
          .MapFrom(FILTER_QUESTION_CODES.vptasLgaListForm.lgaFilter, null, nameof<VptasLgaGridFilterRequest>('lga'))
          .MapFrom(FILTER_QUESTION_CODES.vptasLgaListForm.regionFilter, null, nameof<VptasLgaGridFilterRequest>('region'))
          .BuildMapper();
  }
  
  ngOnInit(): void {
    //throw new Error('Method not implemented.');
  }
  
  ngOnDestroy(): void {
    //throw new Error('Method not implemented.');
  }
  
  formLoad(event: any): void {
    this.loadGridDataOnFormLoad(this.getSpecialistFilterRequest());
  }

  filterData(event: any): void {
    switch (event.field.key) {
      case QUESTION_CODES.vptasLgaListForm.lgaListFilter:
        {
          const filterRequest = this.getSpecialistFilterRequest();
          this.loadGridData(filterRequest);
          break;
        }
    }
  }
  
  actionButton_vptasLgaListGrid_datagrid_custom_createLga_Clicked(event: any) {
    this.router.navigate([ROUTE_CONSTANTS.VptasLga.new]);
  }

  actionButton_vptasLgaListGrid_datagrid_edit_Clicked(event: any): void {
    this.router.navigate(['/', ROUTE_CONSTANTS.VptasLga.prefix, event.event.data.id]);
  }


  private getSpecialistFilterRequest() {  
    const filterModel = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.vptasLgaListForm.lgaList,
      PAGE_NUMBERS.vptasLgaListForm.lgaList,
      SECTION_CODES.vptasLgaListForm.lgaList,
      QUESTION_CODES.vptasLgaListForm.lgaListFilter
    );

   let filterRequest = {};
  if (filterModel != null) {
        filterRequest = this.filterQuestionToFilterModelMapper.Map(filterModel);
  }

    return filterRequest;  
  }
}
